<template>
    <div class="">
        <div class="fixed bg-gray-500 opacity-50 h-screen w-screen top-0 left-0 right-0 z-10"></div>
        <div class="fixed top-0 left-0 right-0 w-full h-full flex items-center justify-center z-20">
            <div class="relative flex flex-col justify-between bg-white z-50 max-h-[95vh] w-[45vw] rounded-lg py-10 px-16 overflow-y-scroll no-scrollbar">
                <svg @click="closeWindow" class="w-8 h-8 absolute top-[10px] right-[12px] text-gray-500 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                <div>
                    <p class="text-2xl mb-8">Новая выплата</p>
                    <div class="grid grid-cols-4 gap-4 mb-8">
                        <PeriodSelection ref="periodSelectionInput" v-model:selectParam="period" labelContent="Период" class="col-span-2"/>
                        <PayoutSelection ref="payoutSelectionInput" v-model:selectParam="payoutType" labelContent="Тип выплаты" class="col-span-2"/>
                        <StaffSelection ref="staffSelectionInput" v-model:selectParam="staff" labelContent="Сотрудник" :options="activeStaffs" class="col-span-2"/>
                        <PriceInput ref="priceInput" v-model:priceParam="price" :priceCurrency="null" labelContent="Размер выплаты" class="col-span-2"/>
                        <CommentInput ref="commentInput" v-model:commentParam="note" labelContent="Комментарий" class="col-span-4"/>
                    </div>
                </div>
                <button @click.stop="createPayout" ref="createPayoutButton" :disabled="createPayoutButtonIsDisabled" type="button" class="text-center bg-custom-blue hover:bg-custom-blue-hover flex items-center justify-center text-white font-medium rounded-lg text-sm px-5 py-2">Добавить</button>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import PeriodSelection from '@/components/InputComponents/PeriodSelection.vue';
    import PayoutSelection from '@/components/InputComponents/PayoutSelection.vue';
    import StaffSelection from '@/components/InputComponents/StaffSelection.vue';
    import PriceInput from '@/components/InputComponents/PriceInput.vue';
    import CommentInput from '@/components/InputComponents/CommentInput.vue';

    export default {
        name: "AddPayoutWindow",
        components: {
            PeriodSelection,
            PayoutSelection,
            StaffSelection,
            PriceInput,
            CommentInput,
        },
        props: {
            isOpened: {
                type: Boolean,
                required: true,
            }
        },
        computed: {
            ...mapState(["staffs"]),
            activeStaffs() {
                return this.staffs.filter(staff => staff.is_active);
            }
        },
        data() {
            return {
                period: null,
                payoutType: null,
                staff: null,
                price: null,
                note: null,
                createPayoutButtonIsDisabled: false,
            }
        },
        methods: {
            validateData() {
                if (!this.period) {
                    this.$refs.periodSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.payoutType) {
                    this.$refs.payoutSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.staff) {
                    this.$refs.staffSelectionInput.selectionIsOpened = true;
                    return false;
                }
                if (!this.price) {
                    this.$refs.priceInput.$refs.priceInput.setCustomValidity("Поле обязательно для заполнения");
                    this.$refs.priceInput.$refs.priceInput.reportValidity();
                    return false;
                }
                return true;
            },
            async createPayout() {
                if (!this.validateData()) return;
                this.createPayoutButtonIsDisabled = true;
                const payload = {
                    staff: this.staff.id,
                    target_period: this.period.date,
                    type: this.payoutType,
                    note: this.note,
                    total: this.price
                }
                const response = await this.$store.dispatch("createPayout", payload);
                if (response.successfully) {
                    this.$notify("Выплата успешно создана!", "black", 3000);
                    this.closeWindow();
                }
                this.createPayoutButtonIsDisabled = false;
            },
            closeWindow() {
                document.body.classList.remove("overflow-hidden");
                this.$emit("update:isOpened", false);
            }
        }
    }
</script>